var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatecourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 11.0006V3.66726C18.3346 2.65473 17.5139 1.83392 16.5013 1.83392H5.5013C4.48878 1.83392 3.66797 2.65473 3.66797 3.66726V18.3339C3.66797 19.3465 4.48878 20.1673 5.5013 20.1673H16.5013C17.5139 20.1673 18.3346 19.3465 18.3346 18.3339V16.9589",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.918 1.83392V12.8339L15.418 10.0839L18.3346 12.8339V4.58392",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatecourse);
export default __webpack_public_path__ + "static/media/Create course.5b979e1ea7beb07c2e236064230ca235.svg";
export { ForwardRef as ReactComponent };